import Vue from "vue";
import Router from "vue-router";

Vue.use(Router);

/* Layout */
import Layout from "@/layout/index";

/* Router Modules */
// import componentsRouter from './modules/components'
// import chartsRouter from './modules/charts'
// import tableRouter from './modules/table'
// import nestedRouter from './modules/nested'

/**
 * Note: sub-menu only appear when route children.length >= 1
 * Detail see: https://panjiachen.github.io/vue-element-admin-site/guide/essentials/router-and-nav.html
 *
 * hidden: true                   if set true, item will not show in the sidebar(default is false)
 * alwaysShow: true               if set true, will always show the root menu
 *                                if not set alwaysShow, when item has more than one children route,
 *                                it will becomes nested mode, otherwise not show the root menu
 * redirect: noRedirect           if set noRedirect will no redirect in the breadcrumb
 * name:'router-name'             the name is used by <keep-alive> (must set!!!)
 * meta : {
    roles: ['admin','editor']    control the page roles (you can set multiple roles)
    title: 'title'               the name show in sidebar and breadcrumb (recommend set)
    icon: 'svg-name'/'el-icon-x' the icon show in the sidebar
    noCache: true                if set true, the page will no be cached(default is false)
    affix: true                  if set true, the tag will affix in the tags-view
    breadcrumb: false            if set false, the item will hidden in breadcrumb(default is true)
    activeMenu: '/example/list'  if set path, the sidebar will highlight the path you set
  }
 */

/**
 * constantRoutes
 * a base page that does not have permission requirements
 * all roles can be accessed
 */
export const constantRoutes = [
  {
    path: "/redirect",
    component: Layout,
    hidden: true,
    children: [
      {
        path: "/redirect/:path(.*)",
        component: () => import("@/views/redirect/index"),
      },
    ],
  },
  {
    path: "/login",
    component: () => import("@/views/login/index"),
    hidden: true,
  },
  {
    path: "/register",
    component: () => import("@/views/register/index"),
    hidden: true,
    meta: { title: "注册" },
  },
  {
    path: "/forget-password",
    component: () => import("@/views/forget-password/index"),
    hidden: true,
    meta: { title: "忘记密码" },
  },
  {
    path: "/state",
    component: Layout,
    children: [
      {
        path: "",
        component: () => import("@/views/state/index"),
        name: "State",
        meta: { title: "用户注册-个人中心" },
      },
    ],
  },
  {
    path: "/auth-redirect",
    component: () => import("@/views/login/auth-redirect"),
    hidden: true,
  },
  {
    path: "/404",
    component: () => import("@/views/error-page/404"),
    hidden: true,
  },
  {
    path: "/401",
    component: () => import("@/views/error-page/401"),
    hidden: true,
  },
  {
    path: "/",
    component: Layout,
    redirect: "/index",
    children: [
      {
        path: "index",
        component: () => import("@/views/index/index"),
        name: "Index",
        meta: { title: "首页", icon: "dashboard", affix: true },
      },
    ],
  },
  {
    path: "/workbench",
    component: Layout,
    redirect: "/workbench/question",
    children: [
      {
        path: "question",
        component: () => import("@/views/workbench/index.vue"),
        name: "WorkbenchQuestion",
        meta: { title: "工作台", icon: "documentation", affix: true },
      },
      {
        path: "do-question",
        component: () => import("@/views/workbench/do-question.vue"),
        name: "DoQuestion",
        meta: { title: "问卷", icon: "documentation", affix: true },
      },
      {
        path: "view",
        component: () => import("@/views/workbench/view.vue"),
        name: "ViewQuestion",
        meta: { title: "查看问卷", icon: "documentation", affix: true },
      },
      {
        path: "report-list",
        component: () => import("@/views/workbench/report-list.vue"),
        name: "WorkbenchReportList",
        meta: { title: "我的报告", icon: "documentation", affix: true },
      },
      {
        path: "report-detail",
        component: () => import("@/views/workbench/report-detail.vue"),
        name: "WorkbenchReportDetail",
        meta: { title: "报告详情", icon: "documentation", affix: true },
      },
      {
        path: "diagnosis",
        component: () => import("@/views/workbench/diagnosis.vue"),
        name: "WorkbenchDiagnosis",
        meta: { title: "我的诊断", icon: "documentation", affix: true },
      },
      {
        path: "diagnosis-detail",
        component: () => import("@/views/workbench/diagnosis-detail.vue"),
        name: "WorkbenchDiagnosisDetail",
        meta: { title: "问卷诊断", icon: "documentation", affix: true },
      },
    ],
  },
  {
    path: "/question",
    component: Layout,
    redirect: "/question/publish",
    children: [
      {
        path: "publish",
        component: () => import("@/views/question/publish"),
        name: "Publish",
        meta: {
          title: "发布问卷",
          icon: "documentation",
          affix: true,
          keep: true,
        },
      },
      {
        path: "collect",
        component: () => import("@/views/question/collect"),
        name: "Collect",
        meta: {
          title: "收集问卷",
          icon: "documentation",
          affix: true,
          keep: true,
        },
      },
      {
        path: "cleaning",
        component: () => import("@/views/question/cleaning"),
        name: "Cleaning",
        meta: {
          title: "清洗问卷",
          icon: "documentation",
          affix: true,
          keep: true,
        },
      },
      {
        path: "statistics",
        component: () => import("@/views/question/statistics"),
        name: "Statistics",
        meta: {
          title: "统计分析",
          icon: "documentation",
          affix: true,
          keeps: true,
        },
      },
      {
        path: "recover",
        component: () => import("@/views/question/recover"),
        name: "Recover",
        meta: {
          title: "回收站",
          icon: "documentation",
          affix: true,
          keep: true,
        },
      },
      {
        path: "view",
        component: () => import("@/views/question/view"),
        name: "View",
        meta: {
          title: "查看",
          icon: "documentation",
          affix: true,
          keeps: true,
        },
      },
      {
        path: "view-log",
        component: () => import("@/views/question/view-log"),
        name: "View",
        meta: {
          title: "查看",
          icon: "documentation",
          affix: true,
          keeps: true,
        },
      },
      {
        path: "create",
        component: () => import("@/views/question/edit"),
        name: "Create",
        meta: { title: "新建问卷", icon: "documentation", affix: true },
      },
      {
        path: "edit",
        component: () => import("@/views/question/edit"),
        name: "Edit",
        meta: {
          title: "编辑问卷",
          icon: "documentation",
          affix: true,
          keeps: true,
        },
      },
    ],
  },
  {
    path: "/user",
    component: Layout,
    redirect: "/user/approve",
    children: [
      {
        path: "approve",
        component: () => import("@/views/user/approve"),
        name: "Approve",
        meta: { title: "待审批用户", icon: "documentation", affix: true },
      },
      {
        path: "register",
        component: () => import("@/views/user/register"),
        name: "RegisterUser",
        meta: { title: "已审批用户", icon: "documentation", affix: true },
      },
      {
        path: "view",
        component: () => import("@/views/user/view"),
        name: "UserView",
        meta: { title: "用户信息", icon: "documentation", affix: true },
      },
      {
        path: "manager",
        component: () => import("@/views/user/manager"),
        name: "UserManager",
        meta: { title: "管理员", icon: "documentation", affix: true },
      },
      {
        path: "expert",
        component: () => import("@/views/user/expert"),
        name: "UserExpert",
        meta: { title: "专家", icon: "documentation", affix: true },
      },
      {
        path: "all-user",
        component: () => import("@/views/user/all-user"),
        name: "AllUser",
        meta: { title: "用户管理", icon: "documentation", affix: true },
      },
      {
        path: "industry",
        component: () => import("@/views/user/industry"),
        name: "Industry",
        meta: { title: "行业管理", icon: "documentation", affix: true },
      },
    ],
  },
  {
    path: "/user-manage",
    component: Layout,
    redirect: "/user-manage/center",
    children: [
      {
        path: "center",
        component: () => import("@/views/user-manage/center"),
        name: "Center",
        meta: { title: "个人中心", icon: "documentation", affix: true },
      },
      {
        path: "edit-password",
        component: () => import("@/views/user-manage/edit-password"),
        name: "EditPassword",
        meta: { title: "修改密码", icon: "documentation", affix: true },
      },
      {
        path: "edit-phone",
        component: () => import("@/views/user-manage/edit-phone"),
        name: "EditPhone",
        meta: { title: "修改手机号", icon: "documentation", affix: true },
      },
    ],
  },
  {
    path: "/role",
    component: Layout,
    redirect: "/role/manager",
    children: [
      {
        path: "manager",
        component: () => import("@/views/role/manager"),
        name: "RoleManage",
        meta: { title: "角色管理", icon: "documentation", affix: true },
      },
    ],
  },
  {
    path: "/crystal-ball",
    component: Layout,
    redirect: "/crystal-ball/index",
    children: [
      {
        path: "index",
        component: () => import("@/views/crystal-ball/index"),
        name: "CrystalBall",
        meta: { title: "指数水晶球", icon: "documentation", affix: true },
      },
    ],
  },
  {
    path: "/report",
    component: Layout,
    redirect: "/report/manage",
    children: [
      {
        path: "manage",
        component: () => import("@/views/report/manage/index"),
        name: "Manage",
        meta: { title: "报告管理", icon: "documentation", affix: true },
      },
      {
        path: "template",
        component: () => import("@/views/report/template/index"),
        name: "Template",
        meta: { title: "报告模版列表", icon: "documentation", affix: true },
      },
      {
        path: "templateDetail",
        component: () => import("@/views/report/template/templateDetail"),
        name: "TemplateDetail",
        meta: { title: "报告模版详情", icon: "documentation", affix: true },
      },
    ],
  },
  {
    path: "/message",
    component: Layout,
    redirect: "/message/template",
    children: [
      {
        path: "template",
        component: () => import("@/views/message/message-template.vue"),
        name: "MessageTemplate",
        meta: { title: "消息模版管理", icon: "documentation", affix: true },
      },
      {
        path: "notice",
        component: () => import("@/views/message/message-notice.vue"),
        name: "MessageNotice",
        meta: { title: "系统通知消息", icon: "documentation", affix: true },
      },
      {
        path: "message",
        component: () => import("@/views/message/message-message.vue"),
        name: "MessageMessage",
        meta: { title: "通知消息", icon: "documentation", affix: true },
      },
      {
        path: "errorLog",
        component: () => import("@/views/message/message-errorLog.vue"),
        name: "ErrorLog",
        meta: { title: "异常日志", icon: "documentation", affix: true },
      },
    ],
  },
  {
    path: "/test",
    component: () => import("@/views/test/index.vue"),
  },
  {
    path: "/document-download",
    component: Layout,
    redirect: "/document-download/systemfiledown",
    children: [
      {
        path: "systemfiledown",
        component: () => import("@/views/document-download/systemfiledown.vue"),
        name: "SystemFileDown",
        meta: { title: "系统文件下载", icon: "documentation", affix: true },
      },
      // {
      //   path: "questionnaire",
      //   component: () => import("@/views/document-download/questionnaire"),
      //   name: "Questionnaire",
      //   meta: { title: "指数问卷", icon: "documentation", affix: true },
      // },
    ],
  },
  {
    path: "/login-record",
    component: Layout,
    redirect: "/login-record/index",
    children: [
      {
        path: "index",
        component: () => import("@/views/login-record/index"),
        name: "loginRecord",
        meta: { title: "操作日志", icon: "documentation", affix: true },
      },
      {
        path: "count",
        component: () => import("@/views/login-record/count"),
        name: "userCount",
        meta: { title: "登录统计", icon: "documentation", affix: true },
      },
      {
        path: "detail",
        component: () => import("@/views/login-record/detail"),
        name: "recordDetail",
        meta: { title: "查看详情", icon: "documentation", affix: true },
      },
    ],
  },
  // {
  //   path: '/documentation',
  //   component: Layout,
  //   children: [
  //     {
  //       path: 'index',
  //       component: () => import('@/views/documentation/index'),
  //       name: 'Documentation',
  //       meta: { title: 'Documentation', icon: 'documentation', affix: true }
  //     }
  //   ]
  // },
  // {
  //   path: '/guide',
  //   component: Layout,
  //   redirect: '/guide/index',
  //   children: [
  //     {
  //       path: 'index',
  //       component: () => import('@/views/guide/index'),
  //       name: 'Guide',
  //       meta: { title: 'Guide', icon: 'guide', noCache: true }
  //     }
  //   ]
  // },
  // {
  //   path: '/profile',
  //   component: Layout,
  //   redirect: '/profile/index',
  //   hidden: true,
  //   children: [
  //     {
  //       path: 'index',
  //       component: () => import('@/views/profile/index'),
  //       name: 'Profile',
  //       meta: { title: 'Profile', icon: 'user', noCache: true }
  //     }
  //   ]
  // }
];

/**
 * asyncRoutes
 * the routes that need to be dynamically loaded based on user roles
 */
export const asyncRoutes = [
  // {
  //   path: '/permission',
  //   component: Layout,
  //   redirect: '/permission/page',
  //   alwaysShow: true, // will always show the root menu
  //   name: 'Permission',
  //   meta: {
  //     title: 'Permission',
  //     icon: 'lock',
  //     roles: ['admin', 'editor'] // you can set roles in root nav
  //   },
  //   children: [
  //     {
  //       path: 'page',
  //       component: () => import('@/views/permission/page'),
  //       name: 'PagePermission',
  //       meta: {
  //         title: 'Page Permission',
  //         roles: ['admin'] // or you can only set roles in sub nav
  //       }
  //     },
  //     {
  //       path: 'directive',
  //       component: () => import('@/views/permission/directive'),
  //       name: 'DirectivePermission',
  //       meta: {
  //         title: 'Directive Permission'
  //         // if do not set roles, means: this page does not require permission
  //       }
  //     },
  //     {
  //       path: 'role',
  //       component: () => import('@/views/permission/role'),
  //       name: 'RolePermission',
  //       meta: {
  //         title: 'Role Permission',
  //         roles: ['admin']
  //       }
  //     }
  //   ]
  // },

  // {
  //   path: '/icon',
  //   component: Layout,
  //   children: [
  //     {
  //       path: 'index',
  //       component: () => import('@/views/icons/index'),
  //       name: 'Icons',
  //       meta: { title: 'Icons', icon: 'icon', noCache: true }
  //     }
  //   ]
  // },

  // /** when your routing map is too long, you can split it into small modules **/
  // componentsRouter,
  // chartsRouter,
  // nestedRouter,
  // tableRouter,

  // {
  //   path: '/example',
  //   component: Layout,
  //   redirect: '/example/list',
  //   name: 'Example',
  //   meta: {
  //     title: 'Example',
  //     icon: 'el-icon-s-help'
  //   },
  //   children: [
  //     {
  //       path: 'create',
  //       component: () => import('@/views/example/create'),
  //       name: 'CreateArticle',
  //       meta: { title: 'Create Article', icon: 'edit' }
  //     },
  //     {
  //       path: 'edit/:id(\\d+)',
  //       component: () => import('@/views/example/edit'),
  //       name: 'EditArticle',
  //       meta: {
  //         title: 'Edit Article',
  //         noCache: true,
  //         activeMenu: '/example/list'
  //       },
  //       hidden: true
  //     },
  //     {
  //       path: 'list',
  //       component: () => import('@/views/example/list'),
  //       name: 'ArticleList',
  //       meta: { title: 'Article List', icon: 'list' }
  //     }
  //   ]
  // },

  // {
  //   path: '/tab',
  //   component: Layout,
  //   children: [
  //     {
  //       path: 'index',
  //       component: () => import('@/views/tab/index'),
  //       name: 'Tab',
  //       meta: { title: 'Tab', icon: 'tab' }
  //     }
  //   ]
  // },

  {
    path: "/error",
    component: Layout,
    redirect: "noRedirect",
    name: "ErrorPages",
    meta: {
      title: "Error Pages",
      icon: "404",
    },
    children: [
      {
        path: "401",
        component: () => import("@/views/error-page/401"),
        name: "Page401",
        meta: { title: "401", noCache: true },
      },
      {
        path: "404",
        component: () => import("@/views/error-page/404"),
        name: "Page404",
        meta: { title: "404", noCache: true },
      },
    ],
  },

  {
    path: "/error-log",
    component: Layout,
    children: [
      {
        path: "log",
        component: () => import("@/views/error-log/index"),
        name: "ErrorLog",
        meta: { title: "Error Log", icon: "bug" },
      },
    ],
  },

  // {
  //   path: '/excel',
  //   component: Layout,
  //   redirect: '/excel/export-excel',
  //   name: 'Excel',
  //   meta: {
  //     title: 'Excel',
  //     icon: 'excel'
  //   },
  //   children: [
  //     {
  //       path: 'export-excel',
  //       component: () => import('@/views/excel/export-excel'),
  //       name: 'ExportExcel',
  //       meta: { title: 'Export Excel' }
  //     },
  //     {
  //       path: 'export-selected-excel',
  //       component: () => import('@/views/excel/select-excel'),
  //       name: 'SelectExcel',
  //       meta: { title: 'Export Selected' }
  //     },
  //     {
  //       path: 'export-merge-header',
  //       component: () => import('@/views/excel/merge-header'),
  //       name: 'MergeHeader',
  //       meta: { title: 'Merge Header' }
  //     },
  //     {
  //       path: 'upload-excel',
  //       component: () => import('@/views/excel/upload-excel'),
  //       name: 'UploadExcel',
  //       meta: { title: 'Upload Excel' }
  //     }
  //   ]
  // },

  // {
  //   path: '/zip',
  //   component: Layout,
  //   redirect: '/zip/download',
  //   alwaysShow: true,
  //   name: 'Zip',
  //   meta: { title: 'Zip', icon: 'zip' },
  //   children: [
  //     {
  //       path: 'download',
  //       component: () => import('@/views/zip/index'),
  //       name: 'ExportZip',
  //       meta: { title: 'Export Zip' }
  //     }
  //   ]
  // },

  // {
  //   path: '/pdf',
  //   component: Layout,
  //   redirect: '/pdf/index',
  //   children: [
  //     {
  //       path: 'index',
  //       component: () => import('@/views/pdf/index'),
  //       name: 'PDF',
  //       meta: { title: 'PDF', icon: 'pdf' }
  //     }
  //   ]
  // },
  // {
  //   path: '/pdf/download',
  //   component: () => import('@/views/pdf/download'),
  //   hidden: true
  // },

  // {
  //   path: '/theme',
  //   component: Layout,
  //   children: [
  //     {
  //       path: 'index',
  //       component: () => import('@/views/theme/index'),
  //       name: 'Theme',
  //       meta: { title: 'Theme', icon: 'theme' }
  //     }
  //   ]
  // },

  // {
  //   path: '/clipboard',
  //   component: Layout,
  //   children: [
  //     {
  //       path: 'index',
  //       component: () => import('@/views/clipboard/index'),
  //       name: 'ClipboardDemo',
  //       meta: { title: 'Clipboard', icon: 'clipboard' }
  //     }
  //   ]
  // },

  // {
  //   path: 'external-link',
  //   component: Layout,
  //   children: [
  //     {
  //       path: 'https://github.com/PanJiaChen/vue-element-admin',
  //       meta: { title: 'External Link', icon: 'link' }
  //     }
  //   ]
  // },

  // 404 page must be placed at the end !!!
  { path: "*", redirect: "/404", hidden: true },
];

const createRouter = () =>
  new Router({
    // mode: 'history', // require service support
    scrollBehavior: () => ({ y: 0 }),
    routes: constantRoutes,
  });

const router = createRouter();

// Detail see: https://github.com/vuejs/vue-router/issues/1234#issuecomment-357941465
export function resetRouter() {
  const newRouter = createRouter();
  router.matcher = newRouter.matcher; // reset router
}

export default router;
